import React from 'react';

import ScrollArrowLink from 'components/Layouts/Form/FormBuilder/ScrollArrowLink';
import AgentContactsModalContent from 'components/shared/AgentContactsModalContent';
import LandingPage from 'components/shared/LandingPage';
import PageHeader from 'components/shared/LandingPage/blocks/PageHeader';
import LandingPagesContainer from 'components/shared/LandingPage/components/Grid';
import NavNotch from 'components/shared/LandingPage/components/NavNotch';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import Modal from 'components/shared/Modal';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useScrollLandingToTop } from 'hooks/useScrollLandingToTop';

import getNavLinks from '../Admin/Page/Landing/utils';
import { usePropertyPortalContextValues, preparePageData } from './functions';
import s from './index.module.css';

function Page(props) {
  useScrollLandingToTop();
  const { data } = props;
  const { isTabletOrMobile } = useMediaBreakpoints();
  const preparedPageData = preparePageData(data);
  const landingData = preparedPageData?.landing;
  const links = getNavLinks(landingData);
  const landingPage = landingData.pages[0];

  const { showAgentContactsModal, closeAgentContactsModal, ...context } = usePropertyPortalContextValues({
    landingData: landingPage,
    page: preparedPageData,
    links,
  });

  return (
    <LandingPageContext.Provider value={context}>
      <LandingPagesContainer className={s.landingPagesContext}>
        <Modal isOpen={showAgentContactsModal} toClose={closeAgentContactsModal} noPortal noPadding>
          <AgentContactsModalContent
            phone={context.page?.communication?.contactPhone}
            whatsapp={context.page?.communication?.whatsapp}
            mobile={context.page?.communication?.messagePhone}
            email={context.page?.communication?.contactEmail}
          />
        </Modal>
        {links.length > 1 && !isTabletOrMobile && <ScrollArrowLink links={links} isPortal />}
        {!isTabletOrMobile && <NavNotch links={links} />}
        <PageHeader links={links} />
        <LandingPage landingPageType={preparedPageData.type} />
      </LandingPagesContainer>
    </LandingPageContext.Provider>
  );
}

export default Page;
